import { Flex, Button, Text, QuestionHelper } from '@pancakeswap/uikit'
import styled from 'styled-components'
import { useTranslation } from '@pancakeswap/localization'
import { useGasPriceManager } from 'state/user/hooks'
import { GAS_PRICE_GWEI, GAS_PRICE } from 'state/types'

export const SettingButton = styled(Button)<{ variant: string }>`
  border-radius: 16px;
  font-weight: 500;
  font-size: 14px;
  line-height: 140%;
  height: unset;
  padding: 0;
  margin-top: 0;
  background-color: ${({ variant }) => (variant === 'primary' ? '#2E81FF' : '#4F90FF1A')};
  color: ${({ variant }) => (variant === 'primary' ? '#fff' : '#2E81FF')};
  margin-right: 0;
  box-shadow: unset;
  height: 36px;
  & + button {
    margin-left: 8px;
  }
  @media screen and (max-width: 700px) {
    font-size: 12px;
  }
`

const ButtonWrapper = styled(Flex)`
  gap: 8px;
  > button {
    width: calc(25% - 6px);
  }

  > * {
    margin: 0 !important;
  }
`

const GasSettings = () => {
  const { t } = useTranslation()
  const [gasPrice, setGasPrice] = useGasPriceManager()

  return (
    <Flex flexDirection="column" width="100%">
      <Flex mb="16px" mt="8px" alignItems="center">
        <Text color="#fff" fontWeight="500" fontSize="14px" lineHeight="140%">
          {t('Default Transaction Speed (GWEI)')}
        </Text>
        <QuestionHelper
          text={
            <Flex flexDirection="column">
              <Text fontSize="14px">
                {t(
                  'Adjusts the gas price (transaction fee) for your transaction. Higher GWEI = higher speed = higher fees.',
                )}
              </Text>
              <Text fontSize="14px" mt="8px">
                {t('Choose “Default” to use the settings from your current blockchain RPC node.')}
              </Text>
            </Flex>
          }
          placement="top"
          ml="8px"
          color="#fff"
        />
      </Flex>
      <ButtonWrapper>
        <SettingButton
          onClick={() => {
            setGasPrice(GAS_PRICE_GWEI.rpcDefault)
          }}
          variant={gasPrice === GAS_PRICE_GWEI.rpcDefault ? 'primary' : 'tertiary'}
        >
          {t('Default')}
        </SettingButton>
        <SettingButton
          onClick={() => {
            setGasPrice(GAS_PRICE_GWEI.default)
          }}
          variant={gasPrice === GAS_PRICE_GWEI.default ? 'primary' : 'tertiary'}
        >
          {t('Standard (%gasPrice%)', { gasPrice: GAS_PRICE.default })}
        </SettingButton>
        <SettingButton
          onClick={() => {
            setGasPrice(GAS_PRICE_GWEI.fast)
          }}
          variant={gasPrice === GAS_PRICE_GWEI.fast ? 'primary' : 'tertiary'}
        >
          {t('Fast (%gasPrice%)', { gasPrice: GAS_PRICE.fast })}
        </SettingButton>
        <SettingButton
          onClick={() => {
            setGasPrice(GAS_PRICE_GWEI.instant)
          }}
          variant={gasPrice === GAS_PRICE_GWEI.instant ? 'primary' : 'tertiary'}
        >
          {t('Instant (%gasPrice%)', { gasPrice: GAS_PRICE.instant })}
        </SettingButton>
      </ButtonWrapper>
    </Flex>
  )
}

export default GasSettings
